import Radio from "@digipost/dds-radio-react";
import classNames from "classnames";
import { ChangeEvent, FC } from "react";

import Translated from "../infrastructure/Translated";
import styles from "./TrueFalseRadioButton.module.css";

type Props = {
  name: string;
  value: boolean;
  change: (event: ChangeEvent<HTMLInputElement>) => void;
  isHorisontal?: boolean;
};

export const TrueFalseRadioButton: FC<Props> = ({
  name,
  value,
  change,
  isHorisontal = false,
}) => {
  return (
    <div>
      <Radio
        className={classNames("radiowrapper", {
          [styles.horisontal]: isHorisontal,
        })}
        name={name}
        value={"false"}
        onChange={change}
        inline={true}
        checked={!value}
        data-testid="radio-button-false"
      >
        <Translated textKey="generic.no" />
      </Radio>
      <Radio
        name={name}
        value={"true"}
        onChange={change}
        inline={true}
        checked={value}
        data-testid="radio-button-true"
      >
        <Translated textKey="generic.yes" />
      </Radio>
    </div>
  );
};
